// File: LottieUploader.js
import { __ } from '@wordpress/i18n';
import { MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';

const LottieUploader = ({ attributes, setAttributes }) => {
	return (
		<div className="vb-lottie-upload-box vb-lottie-upload-start">
			<p className="vb-lottie-heading">
				{__('Upload or Paste Lottie JSON URL:', 'vayu-blocks')}
			</p>

			<MediaUploadCheck>
				<MediaUpload
					onSelect={(media) => {
						if (media && media.url) {
							fetch(media.url)
								.then((res) => res.json())
								.then((json) => {
									setAttributes({
										lottieData: json,
										lottieMediaId: media.id,
										lottieUrl: media.url,
										totaltime: json.op || 100,
										lottieFileName: media.filename || media.title || 'Lottie File',
									});
								})
								.catch(() => {
									console.error('Failed to load JSON');
								});
						}
					}}
					allowedTypes={['application/json']}
					render={({ open }) => (
						<div className='vb-extra-div-front'>
							<button
								className="vb-lottie-btn"
								onClick={open}
							>
								{__('Upload Lottie JSON', 'vayu-blocks')}
							</button>
						</div>
					)}
				/>
			</MediaUploadCheck>

			<input
				type="text"
				className="vb-lottie-url-input"
				value={attributes.lottieUrl || ''}
				onChange={(e) => {
					const url = e.target.value;
					setAttributes({ lottieUrl: url });
					fetch(url)
						.then((res) => res.json())
						.then((json) => setAttributes({ lottieData: json, totaltime: json.op || 100, }))
						.catch(() => console.error('Invalid Lottie URL'));
				}}
				placeholder="https://yourdomain.com/animation.json"
			/>
		</div>
	);
};

export default LottieUploader;
